import React from "react";
import Card from "../../../components/ui/Card";
import { Trophy, Star } from "lucide-react";

const MilestoneWidget = ({ currentSubscribers = 2740 }) => {
  const nextMilestone = 5000;
  const progress = (currentSubscribers / nextMilestone) * 100;
  const remaining = nextMilestone - currentSubscribers;

  return (
    <div className="bg-gradient-to-r from-purple-600 to-indigo-600 p-5 rounded-xl shadow-md text-white">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="font-bold text-lg flex items-center">
            <Trophy size={20} className="mr-2 text-yellow-300" /> 
            Next Milestone: Silver Badge
          </h3>
          <p className="text-purple-100 text-sm mt-1">
            You are <span className="font-bold text-white">{remaining.toLocaleString()}</span> subscribers away!
          </p>
        </div>
        <div className="p-2 bg-white/20 rounded-lg">
           <Star className="text-yellow-300" size={24} fill="currentColor" />
        </div>
      </div>

      <div className="relative pt-1">
        <div className="flex mb-2 items-center justify-between">
          <div className="text-right">
            <span className="text-xs font-semibold inline-block text-purple-100">
              {progress.toFixed(1)}%
            </span>
          </div>
        </div>
        <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-black/20">
          <div
            style={{ width: `${progress}%` }}
            className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-white transition-all duration-1000 ease-out"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default MilestoneWidget;
